import { GUIDE_CARDS } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guidePages/const";
import { FaireAcademyGuide } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/types";
import { useQuery as useFaireAcademyDataQuery } from "@faire/web-api--source/endpoints/www/api/faire-academy/open-with-faire/data/get-hooks";
import { useMemo } from "react";

export const useGuidesWithLikes = (): Array<FaireAcademyGuide> => {
  const { data } = useFaireAcademyDataQuery();
  const likesMap = useMemo(() => {
    if (data?.guides === undefined) {
      return;
    }
    return new Map(data.guides.map((guide) => [guide.identifier, guide.likes]));
  }, [data]);
  return useMemo<Array<FaireAcademyGuide>>(() => {
    return likesMap
      ? GUIDE_CARDS.map((guide) => ({
          ...guide,
          likes: likesMap.get(guide.id),
        }))
      : GUIDE_CARDS;
  }, [likesMap]);
};
